import { Controller } from "@hotwired/stimulus"

const KNOWN_PATTERNS = {
  email: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
  name: "^[A-Za-zÀ-ÖØ-öø-ÿ\\s]+$",
  tel: "^\\+?[0-9()\\-\\s]{10,20}$"
}

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTargets.forEach((input) => {
      input.dataset.lastValidValue = input.value || ""
    })
  }

  handleInput(event) {
    const input = event.target
    const pattern = input.getAttribute("pattern") || ""
    const mode = this.patternMode(pattern)

    if (mode !== "generic") {
      input.value = this.applyKnownFilter(mode, input.value)
    }

    const valid = this.validateAgainstPattern(input)
    if (valid) {
      input.dataset.lastValidValue = input.value
    }
  }

  validateInput(event) {
    this.validateAgainstPattern(event.target)
  }

  patternMode(pattern) {
    if (pattern === KNOWN_PATTERNS.email) return "email"
    if (pattern === KNOWN_PATTERNS.name) return "name"
    if (pattern === KNOWN_PATTERNS.tel) return "tel"
    return "generic"
  }

  applyKnownFilter(mode, value) {
    if (mode === "name") {
      return value.replace(/[^\p{L}\s]/gu, "")
    }

    if (mode === "tel") {
      let cleaned = value.replace(/[^0-9()\-+\s]/g, "")
      cleaned = cleaned.replace(/\+/g, "")

      if (value.trim().startsWith("+")) {
        cleaned = `+${cleaned}`
      }

      return cleaned
    }

    if (mode === "email") {
      let cleaned = value.replace(/\s+/g, "")
      const firstAt = cleaned.indexOf("@")
      if (firstAt >= 0) {
        cleaned = `${cleaned.slice(0, firstAt + 1)}${cleaned.slice(firstAt + 1).replace(/@/g, "")}`
      }
      return cleaned
    }

    return value
  }

  validateAgainstPattern(input) {
    const value = input.value
    const pattern = input.getAttribute("pattern") || ""

    if (!pattern || value.length === 0) {
      input.setCustomValidity("")
      return true
    }

    let regex
    try {
      regex = new RegExp(pattern)
    } catch (_error) {
      input.setCustomValidity("")
      return true
    }

    if (regex.test(value)) {
      input.setCustomValidity("")
      return true
    }

    const label = input.dataset.fieldLabel || "Campo"
    input.setCustomValidity(`${label} não está no formato esperado`)
    return false
  }

  handleExclusiveCheckbox(event) {
    const checkbox = event.target
    if (!checkbox.checked) return

    const group = checkbox.dataset.checkboxGroup
    if (!group) return

    this.element.querySelectorAll('input[type="checkbox"][data-checkbox-group]').forEach((input) => {
      if (input === checkbox) return
      if (input.dataset.checkboxGroup !== group) return

      input.checked = false
    })
  }
}
